export function parse(str) {
  if (!str) {
    return {};
  }

  return _(str)
    .split('&')
    .reduce((acc, param) => {
      const [key, value] = param.split('=');
      acc[key] = value;
      return acc;
    }, {});
}

export function stringify(obj) {
  const query = _(obj)
    .keys()
    .map(arg => `${arg}=${obj[arg]}`)
    .join('&');

  return query ? `?${query}` : query;
}



// WEBPACK FOOTER //
// ./src/shared/utils/query-string.js